import { render } from "./HomeView.vue?vue&type=template&id=33711d2e&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=33711d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33711d2e"]])

export default __exports__